<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <select :id="getId" v-model="currentValue" class="form-control">
            <option value="left">Links</option>
            <option value="right">Rechts</option>
        </select>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';

    export default {
        mixins: [
            fieldInfo
        ],
    }
</script>